/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesTournamentTimelineStageTypeSchema } from "./tournamentTimelineStageTypeSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentTimelineStageSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().nullish(),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get stageType() {
    return goodLuckCoreEntitiesTournamentTimelineStageTypeSchema.optional();
  },
  order: z.optional(z.int()),
  scheduledAtUtc: z.iso.datetime().nullish(),
  delayMinutesAfterPreviousStage: z.int().nullish(),
});
